import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { getProfile } from "../../../services/mentorProfile";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";

const MentorVerificationStatus = () => {
  const [status, setStatus] = useState(null);
  const [loading, setLoading] = useState(true);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    const fetchVerificationStatus = async () => {
      try {
        const response = await dispatch(getProfile({ userId: null }));
        setStatus(response.isVerified);
      } catch (error) {
        toast.error("Error fetching verification status");
      } finally {
        setLoading(false);
      }
    };

    fetchVerificationStatus();
  }, [dispatch]);

  return (
    <div className="flex items-center justify-center min-h-screen bg-gray-100">
      <div className="bg-white p-6 rounded-lg shadow-lg text-center">
        <h2 className="text-xl font-semibold mb-4">
          Mentor Verification Status
        </h2>

        {loading ? (
          <p className="text-blue-500">Loading...</p>
        ) : (
          <>
            {!status && (
              <p className="text-yellow-500 font-semibold">
                Pending Verification
              </p>
            )}
            {status && (
              <>
                <p className="text-green-500 font-semibold">Verified ✅</p>
                {/* // button for navigate to dashboard */}
                <button
                  className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px
                -4 rounded p-2 mt-4"
                  onClick={() => {
                    navigate("/dashboard/home");
                  }}
                >
                  Navigate to Dashboard
                </button>
              </>
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default MentorVerificationStatus;
